// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__uIUVx","header":"styles_header__9lKmw","text":"styles_text__fIH_s","functionLayout":"styles_functionLayout__Luu_G"};